<div class="evercycle-buyback-card-plugin" hive-root>
    <div class="evercycle-buyback-card-plugin__body" [attr.data-actionable]="isActionable()">
        <hive-label [label]="programLabel" size="smallest" weight="semibold"></hive-label>
        @if (isActionable() && renderInfo().valuation; as valuation) {
            <hive-label
                class="evercycle-buyback-card-plugin__caption"
                [label]="valuationCaption"
                size="medium"
            ></hive-label>
            <!--
                A paragraph rather than a hive-label: hive-label only offers label
                sizes and pins its own text colour, and the amount uses the heading
                size and the accent colour.
            -->
            <p class="evercycle-buyback-card-plugin__headline evercycle-buyback-card-plugin__headline--amount">
                {{ valuation.totalAmount | currency: valuation.currency : 'symbol' : '1.0-0' }}
            </p>
            <hive-label
                class="evercycle-buyback-card-plugin__qualifier"
                [label]="valuationQualifier"
                size="smallest"
            ></hive-label>
            @if (validUntilDate(); as deadline) {
                <hive-label
                    class="evercycle-buyback-card-plugin__validity"
                    [label]="'Offer valid until ' + (deadline | date: 'yyyy-MM-dd' : 'UTC')"
                    size="smallest"
                ></hive-label>
            }
        } @else {
            <p class="evercycle-buyback-card-plugin__headline">{{ pendingLabel }}</p>
        }
    </div>
</div>
